import { render, staticRenderFns } from "./ILKids.vue?vue&type=template&id=257ae1bc&scoped=true"
import script from "./ILKids.vue?vue&type=script&lang=js"
export * from "./ILKids.vue?vue&type=script&lang=js"
import style0 from "./ILKids.vue?vue&type=style&index=0&id=257ae1bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257ae1bc",
  null
  
)

export default component.exports